export default{INTEGER:"integer",FLOAT:"float",NUMBER:"number",BOOLEAN:"boolean",STRING:"string"};
//# sourceMappingURL=data-types.js.map
